const bio =
    "Hi, I'm Alex and I've been working in the tech space for over the past decade. I've spent a significant amount of my time developing, managing, and distributing apps in the automotive, event, health, photography, and entertainment space but also have managed my own agency Roadrunner Creative, that focuses on software, content, and photography.";

export default bio;
